import { ActivityCriteria } from "@medapro-types/common/activity/activity";
import api from "./api";
import endpoints from "./endpoints";

export default {
  getActivityUserSettings: async function () {
    const result = await api.get(endpoints.activity.activityUserSettings.get);
    return result.data;
  },
  updateActivityUserSettings: async function (settingsList: any) {
    const result = await api.post(endpoints.activity.activityUserSettings.update, settingsList);
    return result.data;
  },
  createActivity: async function (activityCriterias: ActivityCriteria[]) {
    const result = await api.post(endpoints.activity.create, activityCriterias);
    return result.data;
  },
  deleteOutdatedActivity: async function (effectiveDate: Date | null) {
    const result = await api.post(endpoints.activity.delete, {}, { params: { effectiveDate } });
    return result.data;
  }
};
